/* eslint-disable import/prefer-default-export */

/**
 * does what it says on the tin: removes a copy of the passed object, minus any
 * keys that have an undefined value.
 *
 * @export
 * @param {Object} [obj={}] object that has keys with potentially undefined values
 * @returns {Object} copy of passed object, with keys removed that had undefined values
 */
export function removeKeysWithUndefinedValues(obj = {}) {
  return Object.entries(obj).reduce((acc, curr) => {
    const [k, v] = curr;
    return v === undefined ? acc : { ...acc, [k]: v };
  }, {});
}
